import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import Establishment from "../../models/establishment";

interface EstablishmentCrudAtionsProps {
  establishment: Establishment;
  onUpdateClick: (_: Establishment) => void;
  onDeleteClick: (_: Establishment) => void;
  isDemo?: boolean;
}

const EstablishmentCrudActions: React.FC<EstablishmentCrudAtionsProps> = ({
  establishment,
  onUpdateClick,
  onDeleteClick,
  isDemo,
}) => {
  const editButton = (
    <CTooltip content="Editar">
      <CButton
        className="text-white"
        color="warning"
        onClick={() => {
          onUpdateClick(establishment);
        }}
      >
        <i className="fa fa-pencil"></i>
      </CButton>
    </CTooltip>
  );
  const deleteButton = (
    <CTooltip content="Eliminar">
      <CButton
        className="text-white"
        color="danger"
        onClick={() => {
          onDeleteClick(establishment);
        }}
      >
        <i className="fa fa-trash"></i>
      </CButton>
    </CTooltip>
  );

  return (
    <td className="text-center">
      <CButtonGroup>
        {!isDemo && editButton}
        {!isDemo && deleteButton}
      </CButtonGroup>
    </td>
  );
};

export default EstablishmentCrudActions;
